/**
 * Canonical mime for download/copy format UI and API payloads.
 * Treats jpg / jpeg / pjpeg (and bare "jpg"/"jpeg") as image/jpeg.
 *
 * @param {string|null|undefined} mime
 * @returns {string|null|undefined}
 */
export default function normalizeFormatMimeType(mime) {
  if (mime == null || typeof mime !== 'string') {
    return mime;
  }
  const lower = mime.trim().toLowerCase();
  if (
    lower === 'image/jpg'
    || lower === 'image/jpeg'
    || lower === 'image/pjpeg'
    || lower === 'jpeg'
    || lower === 'jpg'
  ) {
    return 'image/jpeg';
  }
  return mime;
}
